import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import Swiper, { SwiperOptions } from 'swiper';
import { EventsParams } from 'swiper/angular';
import { SwiperComponent as _SwiperComponent } from 'swiper/angular/angular/src/swiper.component';
import { AutoplayOptions } from 'swiper/types';

export interface SwiperImage {
  alt?: string;
  url: string;
}

@Component({
  selector: 'app-image-swiper',
  templateUrl: './image-swiper.component.html',
  styleUrls: ['./image-swiper.component.scss'],
})
export class ImageSwiperComponent implements AfterViewInit, OnChanges {
  @ViewChild('swiperSlideShow', { static: true }) swiper?: _SwiperComponent;

  @Input() images: SwiperImage[] = [];
  @Input() autoplay = true;
  @Input() noTopPadding = false;
  @Input() isLarge?: boolean;

  @Output() slideEnd = new EventEmitter();

  config: SwiperOptions = {
    updateOnWindowResize: false,
    breakpoints: Object.fromEntries(
      [1, 2, 3, 4, 5].map((slides) => [
        120 * (slides + 1),
        {
          slidesPerView: slides,
          slidesPerGroup: slides,
        },
      ])
    ),
    grabCursor: true,
    // swiper.config.loop doesn't seem to work
    loop: true,
    speed: 1500,

    pagination: { clickable: true, dynamicBullets: true },
    // scrollbar: { draggable: true },
  };

  constructor(private readonly ngZone: NgZone) {}

  ngAfterViewInit(): void {
    if (this.autoplay) {
      this.swiper!.swiperRef.autoplay.start();
    }
  }

  onSwiper(swiper: Swiper) {
    console.debug('onSwiperEvent', swiper);
  }

  onSlideChange(params: EventsParams['slideChange']) {
    const [swiper] = params;
    if (this.images.length > 0 && swiper.isEnd) {
      this.ngZone.run(() => this.slideEnd.emit());
      setTimeout(() => {
        if (this.images.length > 0 && swiper.isEnd) {
          this.swiper!.swiperRef.slideTo(0);
        }
      }, (this.config.autoplay as AutoplayOptions)?.delay ?? 4000);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('images')) {
      this.images = changes['images'].currentValue ?? [];
      if (this.images.length < 6) {
        this.config.loop = false;
      }
      this.swiper!.swiperRef?.update();
    }
  }
}
